























































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import BaseEditor from '@front-app/modules/group/highlights/components/BaseEditor.vue';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import HrefInputSection from '@front-app/modules/group/highlights/components/Button/editorSections/HrefInputSection.vue';
import { detectVideoProvider } from '@front-app/components/video/util';
import { extractEmbedSrc, extractVideoIdFromUrl, convertVideoIdToUrl } from '@front-app/util/video';
import { HighlightsVideoComponent } from '@front-app/modules/group/highlights/model';
import { syncedRef } from '@front-app/util/reactivity';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';

export default defineComponent({
	components: {
		BaseEditor,
		BasicTextEditor,
		FormError,
		FormLabel,
		FormSection,
		HelpTooltipBlock,
		HrefInputSection,
	},
	props: {
		value: {
			type: Object as PropType<HighlightsVideoComponent>,
			required: true,
		},
	},
	setup(props, ctx) {
		// Video URL and embed code
		const videoUrl = syncedRef(() => {
			// Fill in the provided source URL or construct one from id and video provider type
			if (props.value.meta.src) {
				return props.value.meta.src;
			}
			if (props.value.meta.videoId && props.value.meta.type) {
				return convertVideoIdToUrl(props.value.meta.videoId, props.value.meta.type);
			}
			return '';
		}).ref;
		const embedCode = ref('');

		const { doMetaInput } = useHighlightsInput(ctx, computed(() => props.value));

		const handleUrlInput = async (url: string) => {
			const type = detectVideoProvider(url);
			const videoId = extractVideoIdFromUrl(url, type);

			if (videoId) {
				doMetaInput({
					src: url,
					type,
					videoId,
				});
			} else {
				videoUrl.value = url;
			}
		};

		const handleEmbedInput = async (newEmbedCode: string) => {
			// Extract src from video embed code
			const srcUrl = extractEmbedSrc(newEmbedCode);
			if (srcUrl) {
				// Extract video provider and video id from src
				const type = detectVideoProvider(srcUrl);
				const videoId = extractVideoIdFromUrl(srcUrl, type);

				doMetaInput({
					src: '',
					type,
					videoId,
				});
			} else {
				embedCode.value = newEmbedCode;
			}
		};

		// Validation
		const validation = v({
			src: {
				value: computed(() => props.value.meta.videoId),
				rules: [required()],
			},
		});

		return {
			videoUrl,
			handleUrlInput,
			embedCode,
			handleEmbedInput,
			validation,
		};
	},
});
